import { Grid, Typography } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import MainContainer from "../components/containers/MainContainer";
import TopBar from "../components/containers/TopBar";
import { t2 } from "../Locale";
import { computeTotoTotal } from "../utils/functions";
import BottomFloat2 from "../components/containers/BottomFloat2";

import CardToto from "../components/CardToto";
import CheckoutToggleOutput from "../components/CheckoutToggleOutput";
import FetchLogin from "../components/Fetch/FetchLogin";
import { setThankYou } from "../redux/items/ThankYou";
import { resetPlaceBetFinal } from "../redux/items/TotoPlaceBetFinal";
import { setLoadingPage } from "../redux/items/PageLoading";
import { setPersonalDetails } from "../redux/items/PersonalDetails";

const TotoCheckout = () => {
  const language = useSelector((state) => state.Language);
  const dispatch = useDispatch();
  const hist = useHistory();

  const token = useSelector((state) => state.login.token);
  const personalDetails = useSelector((state) => state.personalDetails);
  const totoSet = useSelector((state) => state.drawSet.TotoSet);
  const totoPlaceBetFinal = useSelector((state) => state.totoPlaceBetFinal);
  const user = useSelector((state) => state.login.user);

  const bottomRef = useRef(null);

  useEffect(() => {
    if (
      personalDetails?.name === "" ||
      personalDetails?.name === undefined ||
      personalDetails?.name === null
    )
      dispatch(
        setPersonalDetails({
          name: user.name,
          email: user.email,
        })
      );

    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    // eslint-disable-next-line
  }, []);

  const [v, setV] = useState({
    loading: false,
    error: "",
  });

  const setV2 = (v2) => {
    setV((prev) => ({ ...prev, ...v2 }));
  };

  const reqCheckoutToto = FetchLogin("toto/checkout", {
    data: {
      token: token,
      bet: totoPlaceBetFinal,
      name: personalDetails.name,
      email: personalDetails.email,
      web: document.location.origin,
    },
    callbackInit: () => {
      setV2({ error: "" });
      dispatch(setLoadingPage(true));
    },
    callback: (cb) => {
      if (!cb.response.success) {
        if (
          cb.response.message.indexOf(" must be a string") > -1 ||
          cb.response.message.indexOf(" field is required") > -1
        ) {
          dispatch(
            setPersonalDetails({
              name: user.name,
              email: user.email,
            })
          );
        }
        setV2({ error: cb.response.message });
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
      } else {
        dispatch(resetPlaceBetFinal());
        dispatch(setThankYou(cb.response.data.all));
        hist.push("/thank-you");
      }
      dispatch(setLoadingPage(false));
    },
  });

  return (
    <MainContainer
      render={<TopBar leftSide="-1" title="Lottery Bet Slip" />}
      loading={v.loading}
    >
      <CardToto />
      <Typography
        variant="h3"
        style={{
          textAlign: "center",
          fontSize: 24,
          color: "#6D6D6D",
          marginTop: 20,
          fontWeight: "bold",
        }}
      >
        {t2("Personal Details", language)}
      </Typography>

      <Grid
        container
        style={{
          paddingLeft: 16,
          paddingRight: 16,
          marginTop: 10,
          marginBottom: 5,
        }}
      >
        <Grid item xs={12}>
          <div
            style={{
              fontSize: 18,
              width: "80%",
              margin: "0 auto",
              marginTop: 5,
            }}
          >
            <label>Name: </label>
            <b>{personalDetails.name}</b>
            <br />
            <label>Email: </label>
            <b>{personalDetails.email}</b>
            <br />
          </div>
        </Grid>
      </Grid>

      <CheckoutToggleOutput
        tab="credit-balance"
        conditionTab="credit-balance"
        title={<span>Credit Balance</span>}
        result={
          <Typography
            variant="body1"
            style={{
              marginTop: 22,
              marginBottom: -24,
              textAlign: "center",
            }}
          >
            If you would like Top-up your account,
            <br />
            Simply click on the Yellow Bar and follow the steps accordingly
          </Typography>
        }
      />

      <Typography
        dangerouslySetInnerHTML={{ __html: v.error }}
        style={{
          color: "red",
          textAlign: "center",
          paddingTop: 20,
          paddingBottom: 20,
        }}
      />
      <div ref={bottomRef} />
      <BottomFloat2
        total={computeTotoTotal(totoPlaceBetFinal, totoSet)}
        title="Place Bet"
        onClick={() => {
          reqCheckoutToto.handleTrigger();
        }}
      />
    </MainContainer>
  );
};

export default TotoCheckout;
